import { useLocation } from 'react-router';

import { catchAll } from '@sorare/routing';

import { ANY_SPORT_SERIES_TRAINING } from '#src/constants/__generated__/routes.ts';
import { useConfigContext } from '#src/contexts/config/index.ts';
import { matchAnySportPath } from '#src/lib/routing/generateSportPath.ts';

export const useShouldUseTraining = () => {
  const { cardSet } = useConfigContext();
  return !cardSet.replayFinished;
};

export const useIsInTraining = () => {
  const { pathname } = useLocation();
  const shouldUseTraining = useShouldUseTraining();
  return (
    shouldUseTraining &&
    !!matchAnySportPath(catchAll(ANY_SPORT_SERIES_TRAINING), pathname)
  );
};
